const config = {
  ENV: process.env.REACT_APP_ENV || "development",

  BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
  BACKEND_PORT: process.env.REACT_APP_BACKEND_PORT,

  FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL,
  FRONTEND_PORT: process.env.REACT_APP_FRONTEND_PORT,
};

export default config;
